import kitchenInstance from '../instance'

const updateKitchenMonitorConfig = (monitorId, data) => {
	return kitchenInstance.put(`/kitchenMonitorConfigs/${monitorId}`, data)
}

export default updateKitchenMonitorConfig
